import {z} from '@hono/zod-openapi';

import {advertisingCredentialsSchema} from './AdvertisingCommonSchemas';

export const automarketplInspectionQuestionsRequestSchema = z.object({
  tenantId: z.string().uuid(),
  credentials: advertisingCredentialsSchema.nullable(),
});

export const automarketplInspectionQuestionsResponseSchema = z.object({
  inspectionQuestions: z.array(
    z.object({
      pytanieId: z.number().int(),
      kategoriaId: z.number().int(),
      trescKrotka: z.string(),
      trescDluga: z.string(),
      podpowiedz: z.string(),
      dyskwalifikacja: z.number().int(),
    })
  ),
});

export type AutomarketplInspectionQuestions = z.infer<
  typeof automarketplInspectionQuestionsResponseSchema
>;
